import React, { useLayoutEffect } from "react";

import { useLandscapePhone } from "./start/hooks";
import StartPC from "./start/StartPC";
import StartLandscape from "./start/StartLandscape";
import HomeIntro from "./HomeIntro";
import { DEMO } from "../../shared/design-flags";
import { demoProgress } from "../../shared/progress";
import { demoUnopened } from "../../shared/achievements-open";
import { demoEggBalance } from "../../shared/shop/useEggBalance";

// ?demo=1 (the design labs): made-up progress, set before anything reads it.
let demoSet = false;
function setDemo() {
  if (demoSet || !DEMO) return;
  demoSet = true;
  demoProgress();
  demoUnopened([{ id: "needle-threader", level: 2, eggs: 3 }, { id: "round-robin", level: 1, eggs: 2 }]);
  demoEggBalance(120);
}

interface Props {
  // Opens the login modal over the page, the same one the nav's Sign in
  // opens (App owns it). Ranked uses it when signed out.
  onLogin?: () => void;
  onPlayOffline: () => void;
  onStartOnline: (cfg: any) => void;
}

// The start page ("/"). On a computer it is the website page inside the shell
// (navbar, footer); on a phone held sideways it is the game app, full screen,
// with the shell's navbar and footer hidden. The pieces live in ./start.
export default function LobbyPage({ onPlayOffline, onLogin }: Props) {
  setDemo();
  const land = useLandscapePhone();
  const login = onLogin ?? (() => {});

  // The shell's <main>, navbar and footer are not ours to render differently,
  // so the start page says what it needs with classes on <body> (styled in
  // start.module.scss) and takes them off again when it leaves. (Layout effects:
  // set before the first paint, or the first frame is the narrow default page
  // and everything jumps into place a moment later.)
  useLayoutEffect(() => {
    document.body.classList.add("start-page");
    return () => document.body.classList.remove("start-page");
  }, []);
  useLayoutEffect(() => {
    if (!land) return;
    document.body.classList.add("start-app");
    return () => document.body.classList.remove("start-app");
  }, [land]);

  // HomeIntro is the page's heading and summary, visually hidden (see there).
  return (
    <>
      <HomeIntro />
      {land ? <StartLandscape onLogin={login} onLocal={onPlayOffline} /> : <StartPC onLogin={login} onLocal={onPlayOffline} />}
    </>
  );
}
